// Controlled search box used across wizard steps. Plain
// controlled input — debouncing of any network fetch is the
// caller's concern (steps debounce their own fetch).
export function WizardSearch({
  value,
  onChange,
  placeholder,
  ariaLabel,
}: {
  value: string
  onChange: (next: string) => void
  placeholder: string
  ariaLabel: string
}) {
  return (
    <label className="flex items-center w-full rounded-lg py-2.5 px-3 gap-2 bg-background border border-[#C9C2B6] focus-within:border-[#B86A2D]">
      <svg width="15" height="15" viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <circle cx="7" cy="7" r="4.5" stroke="#9A938A" strokeWidth="1.4" />
        <path
          d="M10.5 10.5L13.5 13.5"
          stroke="#9A938A"
          strokeWidth="1.4"
          strokeLinecap="round"
        />
      </svg>
      <input
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={ariaLabel}
        data-testid="wizard-search"
        className="grow min-w-0 bg-transparent text-sm leading-5 text-[#1E1B17] placeholder:text-[#9A938A] outline-none"
      />
    </label>
  )
}
